angular.module('impactx.cscontract').directive('ixContractTolerance', function(){
    return {
        scope: {
            data: "=",
            trns: "=",
            isAmount: "="
        },
        restrict: 'E',
        controller: 'CSCToleranceCtrl',
        controllserAs: 'cscToleranceCtrl',
        templateUrl: 'modules/cscontract/templates/csctolerance.directive.tmpl.html'
    };
});